// extracted by mini-css-extract-plugin
export default {"container":"auth_container__5akEf","btn":"auth_btn__76NSA","eye":"auth_eye__DEOKs","input":"auth_input__PgWVR","hint":"auth_hint__0-eAO","links":"auth_links__ohAES"};